import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { ActivatedRoute } from '@angular/router';
import { Data } from '../../models/data';
import { NavController } from '@ionic/angular';
import { BarcodeScannerOptions, BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

export interface DialogData {
  animal: string;
  name: string;
}


@Component({
  selector: 'app-posm-merchandise-ddet',
  templateUrl: './posm-merchandise-ddet.page.html',
  styleUrls: ['./posm-merchandise-ddet.page.scss'],
})
export class PosmMerchandiseDdetPage implements OnInit {

  data = new Data();
  myId: any;
  payment = {
    account_number: null,
    amount: null
  };
  product: any;
  scannedData: any;
  barcodeScannerOptions: BarcodeScannerOptions;
  active = false;
  verify = false;
  error = false;
  myresponse: any;
  myprod = {
    id: null,
    price: null,
    desc: null
  }

  reloadtype: any;
  
  constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute, private barcodeScanner: BarcodeScanner, private navCtrl: NavController, public dialog: MatDialog, private spinner: NgxSpinnerService) {

    this.myId = this.activatedRoute.snapshot.paramMap.get('myid');
    this.data =  {
      id: 4,
      name: 'getProduct',
      content: this.myId
    };

    this.barcodeScannerOptions = {
      showTorchButton: true,
      showFlipCameraButton: true
    };

  }

  ngOnInit() {
    this.apiService.postData(this.data).subscribe((response) => {
      this.product = response.data;
    });
  }

  getCatName() {
    if (this.product) {
      return this.product[0].dexpay_label;
    } else {
      return null;
    }
  }

  getProdName() {
    if (this.product) {
      return this.product[0].name;
    } else {
      return null;
    }
  }

  getProdImage() {
    if (this.product) {
      return '/assets/img/' + this.product[0].image;
    } else {
      return null;
    }
  }

  scanCode() {
    this.barcodeScanner
      .scan()
      .then(barcodeData => {
        this.scannedData = barcodeData;
        this.payment.account_number = this.scannedData.text;
      })
      .catch(err => {
        console.log('Error', err);
      });
  }

  scanCode2() {
      this.barcodeScanner
        .scan()
        .then(barcodeData => {
          this.scannedData = barcodeData;
          this.payment.amount = this.scannedData.text;
        })
        .catch(err => {
          console.log('Error', err);
        });
  }

  checkInput() {
    if (this.payment.account_number !== null && this.payment.amount !== null) {
      this.active = true;
    } else {
      this.active = false;
    }
  }

  submit() {
    this.spinner.show();

    const dt = {
        postcode: this.payment.account_number,
        item: this.myprod.desc,
        connote: this.payment.amount,
        user: localStorage.getItem('user')
      };

    this.data =  {
        id: 5,
        name: 'addPrepaid',
        content: dt
      };

      console.log(this.data);

        this.apiService.postData(this.data).subscribe((res) => {
          this.myresponse = res;

          if (this.myresponse === 'Failed') {
            this.navCtrl.navigateForward('/members/posm-merchandising');
            this.spinner.hide();
            console.log(res);
          } else {
            this.navCtrl.navigateForward('/members/posm-merchandising');
            this.spinner.hide();
            console.log(res);
          }
      });

  }

  setProduct(id, price, desc) {

    this.myprod.id = id;
    this.myprod.price = price;
    this.myprod.desc = desc;

  }


  verification() {
    const wallet = localStorage.getItem('wallet');
    const test = wallet.replace(',', '');
    const balance = Number.parseFloat(test) - this.payment.amount;

    console.log(test + ' ' + balance + ' ' + this.payment.amount);

    this.data =  {
      id: 10,
      name: 'checkAccountNo',
      content: this.payment.account_number
    };

    this.apiService.postData(this.data).subscribe((response) => {
      console.log(response);
      if ( response.data[0].isokay === 1 ) {
        this.verify = true;
        this.error = false;
      } else {
        this.verify = false;
        this.error = true;
      }
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogPOSDropPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  getLimit() {
    if (this.myId === '126') {
      return 12;
    } if (this.myId === '136') {
      return 16;
    } if (this.myId === '138') {
      return 15;
    } else {
      return 14;
    }
  }

}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogPOSDropPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
